import { render, staticRenderFns } from "./userstorageconfig-edit.vue?vue&type=template&id=76a2f122&"
import script from "./userstorageconfig-edit.vue?vue&type=script&lang=ts&"
export * from "./userstorageconfig-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports